import React from 'react';
import { Box, Typography, Dialog } from '@mui/material';
import { t } from 'i18next';

function CustomModal({ open, onClose, content, onButtonOneClick, onButtonTwoClick }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      disablePortal
      slotProps={{
        root: {
          sx: {
            position: 'absolute',
          },
        },
      }}
      PaperProps={{
        sx: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '338px',
          margin: 0,
          padding: '32px 24px',
          display: 'grid',
          justifyItems: 'center',
          alignItems: 'center',
          gap: '32px',
          backgroundColor: '#fff',
          boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <Box>
        <Typography
          sx={{
            fontFamily: 'HyundaiHeadMedium',
            fontWeight: 500,
            fontSize: '17px',
            color: 'black',
            textAlign: 'center',
            whiteSpace: 'pre-line',
          }}
        >
          {content}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
        <Box
          sx={{
            width: '139px',
            height: '40px',
            background: '#767676',
            fontFamily: 'HyundaiHeadMedium',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#fff',
            cursor: 'pointer',
          }}
          onClick={onButtonOneClick}
        >
          {t('4540_chat_end.cancel')}
        </Box>
        <Box
          sx={{
            width: '139px',
            height: '40px',
            background: '#002D63',
            fontFamily: 'HyundaiHeadMedium',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#fff',
            cursor: 'pointer',
          }}
          onClick={onButtonTwoClick}
        >
          {t('4540_chat_end.end')}
        </Box>
      </Box>
    </Dialog>
  );
}

export default CustomModal;
